export default __webpack_public_path__ + "static/media/brandinglogo.7c04d7bc.svg";